import { lazy } from 'react'

export default {
    path: '/report/regolarita-consuntivi',
    title: 'Controllo regolarità consuntivi',
    authenticated: true,
    component: lazy(() => import('./filter'))
}